import { put, call, fork, select, takeEvery, all } from 'redux-saga/effects';

import * as accountManagersModule from '../modules/accountManagers.module';
import * as Api from '../../core/api';

import { reset as resetForm } from 'redux-form';

export function* fetchAccountManagers({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.accountManagers.sort);
  const { response, error } = yield call(Api.accountManagers.fetchAccountManagers,
    { page, itemsPerPage, sort });

  if (response) {
    yield put(accountManagersModule.fetchAccountManagersSuccess(response));
  } else {
    yield put(accountManagersModule.fetchAccountManagersFail(error));
  }
}

export function* watchFetchAccountManagers() {
  yield takeEvery(accountManagersModule.fetchAccountManagers.getType(), fetchAccountManagers);
}

export function* fetchAllAccountManagers() {
  const { response, error } = yield call(Api.accountManagers.fetchAllAccountManagers);

  if (response) {
    yield put(accountManagersModule.fetchAllAccountManagersSuccess(response));
  } else {
    yield put(accountManagersModule.fetchAllAccountManagersFail(error));
  }
}

export function* watchFetchAllAccountManagers() {
  yield takeEvery(accountManagersModule.fetchAllAccountManagers.getType(), fetchAllAccountManagers);
}

export function* addAccountManager({ payload: accountManager }) {
  const { response, error } = yield call(Api.accountManagers.addAccountManager, accountManager);

  if (response) {
    yield put(accountManagersModule.addAccountManagerSuccess(response));
    yield put(accountManagersModule.closeUpdateAccountManager());
    yield put(resetForm('addAccountManager'));
  } else {
    yield put(accountManagersModule.addAccountManagerFail(error));
  }
}
export function* watchAddAccountManager() {
  yield takeEvery(accountManagersModule.addAccountManager.getType(), addAccountManager);
}

export function* updateAccountManager({ payload: { accountManagerId, accountManager } }) {
  const { response, error } = yield call(Api.accountManagers.updateAccountManager, { accountManagerId, accountManager });

  if (response) {
    yield put(accountManagersModule.updateAccountManagerSuccess({
      accountManagerId,
      accountManager: {
        ...accountManager,
        avatar: accountManager.avatar,
      },
    }));
    yield put(accountManagersModule.closeUpdateAccountManager());
    yield put(resetForm('addAccountManager'));
  } else {
    yield put(accountManagersModule.updateAccountManagerFail(error));
  }
}
export function* watchUpdateAccountManager() {
  yield takeEvery(accountManagersModule.updateAccountManager.getType(), updateAccountManager);
}


export default function* watchAccountManagers() {
  return yield all([
    fork(watchFetchAccountManagers),
    fork(watchFetchAllAccountManagers),
    fork(watchAddAccountManager),
    fork(watchUpdateAccountManager),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/accountManagers.saga.js
 **/